import { Component } from '../../helpers/compiler';
import { Dialog } from './index';

@Component({ className: 'js-dialog' })
export class DialogComponent {
	constructor(private element: HTMLDialogElement) {
		new Dialog(element);
	}
}
